import * as React from "react";
import { Panel, PrimaryButton, Stack, Persona, PersonaSize, ILabelStyles, FontSizes } from "@fluentui/react";
import authModule from "../utilities/AuthModule";
import { LanguageContext } from "../utilities/LocalizationModule";
import { IAuthAccount } from "../src/taskpane/interfaces/IAuthTokenResultDto";
import { panelStyles } from "../src/taskpane/config/controlStyles";

interface MainHeadingProps {
    isOpen: boolean,
    closePanel: () => void,
    profilePicURL: string,
}

const ProfilePanel: React.FunctionComponent<MainHeadingProps> = ({
    isOpen,
    closePanel,
    profilePicURL,
}: MainHeadingProps) => {

    const [authAccount, setAuthAccount] = React.useState<IAuthAccount>(null);

    const languageStrings = React.useContext(LanguageContext);

    React.useEffect(() => {
        const setupAsyncWrapper = async () => {
            const account: IAuthAccount = await authModule.getAccount();
            setAuthAccount(account);
        };
        setupAsyncWrapper();
    }, []);

    return (
        <Panel
            isOpen={isOpen}
            closeButtonAriaLabel="Close"
            headerText={languageStrings.Account}
            styles={panelStyles}
            isHiddenOnDismiss={true}
            onDismiss={() => closePanel()}
        >
            <div className="xb-setting-container">
                <div style={{ marginTop: 10, marginBottom: 18 }}>
                    <Stack tokens={{ childrenGap: 10 }}>
                        <Persona
                            imageUrl={profilePicURL}
                            text={authAccount?.displayName}
                            secondaryText={authAccount?.username}
                            size={PersonaSize.size40}
                        />
                        <PrimaryButton
                            text={languageStrings.Disconnect}
                            className="logout"
                            onClick={() => {
                                authModule.clearPersistedAuthState();
                                window.location.replace(process.env.baseUri + "/auth.html");
                            }}
                            allowDisabledFocus
                        />
                    </Stack>
                </div>
            </div>
        </Panel>);
};

const preferencesLabelStyle: ILabelStyles = {
    root: {
        fontSize: FontSizes.size18,
        lineHeight: "24px",
    }
};

export default ProfilePanel;